import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./listingSummaryCard.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { getListingLogo, getListingPublisher } from '~/modules/helpers/listingHelper';
import { Routes } from '~/modules/routes';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { listingStore, selectListingFromUrl } from '~/modules/stores/listingStore';
import { images } from '~/modules/utilities/assetUtilities';
import { getListingId } from '~/modules/utilities/listing_utils';
class ListingSummaryCard extends LightningElement {
  constructor(...args) {
    super(...args);
    this.listing = null;
  }
  i18nStoreCallback(i18n) {
    this.labels = i18n.try.listingSummaryCard;
    this.sharedLabels = i18n.shared;
  }
  get reviewCount() {
    return this.listing?.reviewsSummary?.reviewCount || null;
  }
  get averageRating() {
    return this.listing?.reviewsSummary?.averageRating || null;
  }
  get listingId() {
    return getListingId(this.listing);
  }
  get listingUrl() {
    return `/${Routes.LISTING}?listingId=${this.listingId}`;
  }
  get decorationImage() {
    return images.tryListingSummaryDecoration;
  }
  get listingTitle() {
    return this.listing?.name || '';
  }
  get logo() {
    return getListingLogo(this.listing);
  }
  get logoAlt() {
    const publisherName = this.publisherName;
    return publisherName ? i18nStore.getState().i18n.shared.logoAlt({
      LOGO_NAME: publisherName
    }) : this.sharedLabels.deafultLogoAlt;
  }
  get publisherName() {
    if (!this.publisher?.name) {
      return '';
    }
    const {
      i18n
    } = i18nStore.getState();
    const result = i18n.listingTile.labelByMessage({
      PUBLISHER: this.publisher.name
    });
    return result;
  }
  get publisher() {
    return getListingPublisher(this.listing);
  }
  get website() {
    return this.publisher?.website || null;
  }
  get email() {
    return this.publisher?.email || null;
  }
  get phone() {
    return this.publisher?.phoneNumber || null;
  }
  get showDetails() {
    return !!this.website || !!this.email || !!this.phone;
  }
  get details() {
    const result = [];
    const website = this.website;
    if (website) {
      result.push({
        id: 'website',
        title: this.labels.website,
        links: [{
          text: website,
          href: website
        }]
      });
    }
    const email = this.email;
    if (email) {
      result.push({
        id: 'email',
        title: this.labels.email,
        links: [{
          text: email,
          href: `mailto:${email}`
        }]
      });
    }
    const phone = this.phone;
    if (phone) {
      result.push({
        id: 'phone',
        title: this.labels.phone,
        links: [{
          text: phone,
          href: `tel:${phone}`
        }]
      });
    }
    return result;
  }

  // I would prefer to leave this here so we know how to enable analytics for this component
  // It took me a while to figure out how to do this
  // the following must also be added to the outer container of the card html: onanalytics={handleAnalytics}
  // handleAnalytics(event: CustomEvent) {
  //     if (event.detail.eventType === 'click') {
  //         event.detail.topic = AnalyticsEventTopic.TRY_FREE_CLICK;
  //     }
  // }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ListingSummaryCard, {
  wire: {
    listing: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: listingStore,
          selector: selectListingFromUrl
        };
      }
    },
    i18nStoreCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ListingSummaryCard, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;